import { render, staticRenderFns } from "./Privacy_202504.vue?vue&type=template&id=38596f30&scoped=true"
import script from "./Privacy_202504.vue?vue&type=script&lang=js"
export * from "./Privacy_202504.vue?vue&type=script&lang=js"
import style0 from "./Privacy_202504.vue?vue&type=style&index=0&id=38596f30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38596f30",
  null
  
)

export default component.exports